var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconActivity24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.205 3.213a.75.75 0 0 1 .714.516l5.112 15.55 2.126-6.558.046-.11a.75.75 0 0 1 .667-.409H22a.75.75 0 0 1 0 1.5h-3.584l-2.666 8.224a.75.75 0 0 1-1.426.004L9.211 6.379l-2.206 6.805a.75.75 0 0 1-.713.518H2a.75.75 0 1 1 0-1.5h3.746l2.747-8.47.046-.11a.75.75 0 0 1 .666-.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActivity24);
export default __webpack_public_path__ + "static/media/icon_activity_24.fa06d7d52e514a191436759241d50fa4.svg";
export { ForwardRef as ReactComponent };